export function isDemoClientView(params: Record<string, unknown> | undefined | null): boolean {
    const value = params?.as_client
    return value === "1" || value === 1 || value === true
}

/** На ?as_client=1 форма подписания — клиентская, даже если в кабинете залогинен инициатор. */
export function signingUserForContractForm<T>(
    userSession: T | null | undefined,
    params?: Record<string, unknown> | null,
): T | null {
    if (isDemoClientView(params)) {
        return null
    }
    return userSession ?? null
}
